import { ProductSummary } from '@features/add-to-cart-page/typings/Product';

export function mapPersonalPrice(
  personalPrice: ProductSummary['personalPrice'] | undefined,
  itemQuantity: number | undefined = 1
) {
  if (!personalPrice) {
    return undefined;
  }

  return {
    price: {
      includingVat: itemQuantity * personalPrice.price.includingVat,
      excludingVat: itemQuantity * (personalPrice.price.excludingVat ?? 0)
    },
    labelText: ''
  };
}
